import { render, staticRenderFns } from "./OwnHouse.vue?vue&type=template&id=05a35d78&scoped=true&"
import script from "./OwnHouse.vue?vue&type=script&lang=js&"
export * from "./OwnHouse.vue?vue&type=script&lang=js&"
import style0 from "./OwnHouse.vue?vue&type=style&index=0&id=05a35d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a35d78",
  null
  
)

export default component.exports